import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { TTTFollowUpModel } from 'src/app/models/TTTFollowUpModel';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { ProtocolsearchComponent } from '../protocolsearch/protocolsearch.component';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientModel } from 'src/app/models/PatientsModel';
import { CanserService } from 'src/app/services/CanserService';
import { CanserModel } from 'src/app/models/CanserModel';
import { TTTFollowUpService } from 'src/app/services/TTTFollowUpService';
import swal from 'sweetalert2';
import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { Router } from '@angular/router';
import { BookingSearchComponent } from '../booking-search/booking-search.component';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
@Component({
  selector: 'app-tttfollow-up',
  templateUrl: './tttfollow-up.component.html',
  styleUrls: ['./tttfollow-up.component.css']
})
export class TTTFollowUpComponent implements OnInit {

  tttplanid = '' ;
  tttplanname = '' ;
  pacode = '' ;
  paname = '';
  tttnoofcycle = '' ;
  tttdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cbchb = '' ;
  cbctlc = '' ;
  cbcpnl = '';
  cbcplat = '' ;
  protocol = '' ;
  protocolname = '';
  tttdose = 0 ;
  tttunit = '' ;
  unitname ='';
  tttrote = '' ;
  tttday = '' ;
  tttcycleno = '' ;
  tttnextcycle = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  doctor = '' ;
  docName = '';
  tttnotes = '' ;
  compcode = '1' ;
  userid = '' ;

  diganosis = '';
  cancerid = '';
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  doctorsList: DoctorsModel[] = [];
  TTTFollowUpList : TTTFollowUpModel[]=[];
  finalunitsList :  UnitsModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();
  styleColor =[];
  constructor(public tttfollowup : TTTFollowUpModel,
              public tttfollowupservice : TTTFollowUpService,
              public doctorsService : DoctorsService,
              public unitsService : UnitsService,
              public protocolhd : ProtocolHDModel,
              public protocolhdservice : ProtocolHDService,
              public patients : PatientModel,
              public dataBankService : DataBankService,
              public canserservice :CanserService,
              private dialogref: MatDialog,
              public storage: LocalStorageService,
              public route: Router) { }

  ngOnInit(): void {
    this. retriveDoctorsLookupTop();
    this. LoockupUnits();

  }
  retriveDoctorsLookupTop() {
    this.doctorsService
      .getDoctorsLookupTop(this.compcode)
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsList[i] = data[i];
        }
        console.log(data);
      });
  }
  LoockupUnits(){
    this.unitsService
    .getUnitsLookupTop(this.compcode)
    .subscribe((data: UnitsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.finalunitsList[i] = data[i];
      }
      //console.log(data);
    });
  }
  LoockupProtocols(){
    const dialogRef = this.dialogref.open(ProtocolsearchComponent,
      {
        data: {
          dataKey: this.protocolhd
        }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
    const dialogSubmitSubscription =
         dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.protocol = result.prHdCode;
          this.protocolname = result.prHdName;

          dialogSubmitSubscription.unsubscribe();

        });
  }
  ////////-----------------------
  openDialog(){
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patients,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.pacode = result.patientCode;
        this.paname = result.patientFName;

        this.diganosis = result.diagnosis;

        this.cancerid = result.cancerID;
        this.canserservice.getCancer(this.cancerid,this.storage.retrieve('stgcompCode')).subscribe((data: CanserModel) => {
          this.cancerid  =this.cancerid + ' ' +  data.cancerName;
        });
        this.RetriveAll();
        dialogSubmitSubscription.unsubscribe();

      });
      this.RetriveAll();
  }
  OpenDialogRes(){
    const dialogRef = this.dialogref.open(BookingSearchComponent, {
      data: {
        dataKey: this.patients,
        resdate : this.tttdate
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.pacode = result.patientCode;
        this.paname = result.patientName;

        this.dataBankService.getPatient(this.pacode, this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
          this.diganosis = data.diagnosis;
          this.cancerid = data.cancerID;
        this.canserservice.getCancer(this.cancerid,this.storage.retrieve('stgcompCode')).subscribe((data: CanserModel) => {
          this.cancerid  =this.cancerid + ' ' +  data.cancerName;
        });
        });

        // this.RetriveAll();
        dialogSubmitSubscription.unsubscribe();
        this.RetriveAll();
      });
      this.RetriveAll();
  }
  ///////------------------------
  RetriveAll(){
    this.TTTFollowUpList =[];
    this.tttfollowupservice.GetTTTFollowUp(this.pacode).subscribe((data: TTTFollowUpModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.TTTFollowUpList[i] = data[i];
        this.TTTFollowUpList[i].tttdate = formatDate(data[i].tttdate, 'yyyy-MM-dd', 'en');
        this.TTTFollowUpList[i].tttnextcycle = formatDate(data[i].tttnextcycle, 'yyyy-MM-dd', 'en');

    }
    });
  }
  RetrivePatient(){
    this.dataBankService.getPatient(this.pacode, this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.paname = data.patientFName;
      this.diganosis = data.diagnosis;
      this.cancerid = data.cancerID;
    this.canserservice.getCancer(this.cancerid,this.storage.retrieve('stgcompCode')).subscribe((data: CanserModel) => {
      this.cancerid  =this.cancerid + ' ' +  data.cancerName;});
    });
   this.RetriveAll();
  }
  Save_Data(){
   if(this.pacode == '' || this.pacode == null){return;}
      this.tttfollowup.tttplanid = this.tttplanid
      this.tttfollowup.tttplanname = this.tttplanname
      this.tttfollowup.pacode = this.pacode
      this.tttfollowup.tttnoofcycle = this.tttnoofcycle
      this.tttfollowup.tttdate = this.tttdate
      this.tttfollowup.cbchb = this.cbchb
      this.tttfollowup.cbctlc = this.cbctlc
      this.tttfollowup.cbcpnl = this.cbcpnl
      this.tttfollowup.cbcplat = this.cbcplat
      this.tttfollowup.protocol = this.protocol
      this.tttfollowup.tttdose = this.tttdose
      this.tttfollowup.tttunit = this.tttunit
      this.tttfollowup.tttrote = this.tttrote
      this.tttfollowup.tttday = this.tttday
      this.tttfollowup.tttcycleno = this.tttcycleno
      this.tttfollowup.tttnextcycle = this.tttnextcycle
      this.tttfollowup.doctor = this.doctor
      this.tttfollowup.tttnotes = this.tttnotes
      this.tttfollowup.compcode = this.storage.retrieve('stgcompCode');
      this.tttfollowup.userid = this.storage.retrieve('stgUserId')
      this.tttfollowup.modifieddate = formatDate(this.modifieddate, 'yyyy-MM-dd', 'en');
      this.tttfollowupservice.AddTTTFollowUp(this.tttfollowup).subscribe(
        (data) => {
          this.mesgSave();
          this.RetriveAll();

        },
        (error) => {
          alert(error);
        }
      );



  }
  New_Data(){
    this.TTTFollowUpList =[];
    this.tttplanid = '' ;
    this.tttplanname = '' ;
    this.pacode = '' ;
    this.paname = '';
    this.tttnoofcycle = '' ;
    this.tttdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.cbchb = '' ;
    this.cbctlc = '' ;
    this.cbcpnl = '';
    this.cbcplat = '' ;
    this.protocol = '' ;
    this.protocolname = '';
    this.tttdose = 0 ;
    this.tttunit = '' ;
    this.unitname ='';
    this.tttrote = '' ;
    this.tttday = '' ;
    this.tttcycleno = '' ;
    this.tttnextcycle = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.doctor = '' ;
    this.docName = '';
    this.tttnotes = '' ;
    this.diganosis = '';
    this.cancerid = '';
  }
  Delete_Data(){

    this.tttfollowupservice.DelTTTFollowUp(this.pacode,this.tttdate).subscribe((data: TTTFollowUpModel) => {
      this.tttnoofcycle = '' ;
      this.tttdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.cbchb = '' ;
      this.cbctlc = '' ;
      this.cbcpnl = '';
      this.cbcplat = '' ;
      this.protocol = '' ;
      this.protocolname = '';
      this.tttdose = 0 ;
      this.tttunit = '' ;
      this.unitname ='';
      this.tttrote = '' ;
      this.tttday = '' ;
      this.tttcycleno = '' ;
      this.tttnextcycle = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.doctor = '' ;
      this.docName = '';
      this.tttnotes = '' ;
    this.RetriveAll();

    });
  }delete
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.Delete_Data();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );

  }
  SelectTTTFollowUp(res : TTTFollowUpModel){
    this.tttnoofcycle = '' ;
    this.tttdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.cbchb = '' ;
    this.cbctlc = '' ;
    this.cbcpnl = '';
    this.cbcplat = '' ;
    this.protocol = '' ;
    this.protocolname = '';
    this.tttdose = 0 ;
    this.tttunit = '' ;
    this.unitname ='';
    this.tttrote = '' ;
    this.tttday = '' ;
    this.tttcycleno = '' ;
    this.tttnextcycle = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.doctor = '' ;
    this.docName = '';
    this.tttnotes = '' ;

    this.tttplanid = res.tttplanid;
    this.tttplanname = res.tttplanname;
    this.pacode = res.pacode;
    this.tttnoofcycle = res.tttnoofcycle;
    this.tttdate = res.tttdate;
    this.cbchb = res.cbchb;
    this.cbctlc = res.cbctlc;
    this.cbcpnl = res.cbcpnl;
    this.cbcplat = res.cbcplat;
    this.protocol = res.protocol;
    this.protocolhdservice.getProtocolHD(this.protocol).subscribe((data: ProtocolHDModel) => {
        this.protocolname = data.prHdName});
    this.tttdose = res.tttdose;
    this.tttunit = res.tttunit;
    this.tttrote = res.tttrote;
    this.tttday = res.tttday;
    this.tttcycleno = res.tttcycleno;
    this.tttnextcycle = res.tttnextcycle;
    this.doctor = res.doctor;
    this.tttnotes = res.tttnotes;
    this.submitClicked.emit(this.tttfollowup);

  }
  PrintFollowUp(){
    this.storage.store('stgPar', this.pacode);
    this.route.navigate(['report-vewier', 'CocReports/TTTFollowUp']);
  }
  mesgSave() {
    swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,

      timer: 1500,
    });
  }
}
